import React from "react";
import "./Notice.css";
import ImageCarousel from "./ImageCarousel";
import CenterPhoto from "../images/photo1.jpeg";
const NoticeDetails = [
  {
    id: 1,
    name: "Admission open",
  },
  {
    id: 2,
    name: "First Batch Will Start From Octobar",
  },
];

const ImageSlider = [
  {
    url: CenterPhoto,
    title: "first",
  },
  {
    url: "https://img.freepik.com/premium-photo/there-is-picture-mountain-with-lake-foreground-generative-ai_900833-14026.jpg",
    title: "second",
  },
  {
    url: "https://img.freepik.com/premium-photo/2d-flat-tropical-forest-lake-backgroundgenerative-ai_710973-7306.jpg",
    title: "third",
  },
];

const Notice = () => {
  return (
    <div className="ntc">
      <div className="image_carouse">
        <ImageCarousel ImageSlider={ImageSlider} />
      </div>
      <div className="notice-section">
        <div className="latest-news news">
          <span>Latest news</span>
          <ul>
            {NoticeDetails.map((rank, i) => {
              if (i + 1 === NoticeDetails.length) {
                return (
                  <li className="blink">
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {rank.name} - Click Me
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        <div className="all-news news">
          <span>All news</span>
          <ul>
            {NoticeDetails &&
              NoticeDetails?.map((a) => (
                <li key={a.id}>
                  <i class="fa-solid fa-circle-dot fa-xs"></i>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {a.name}
                  </a>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Notice;
